import type { ReactElement } from 'react';
import { t } from '@fetmode/i18n';
import { Button } from '@fetmode/ui';

import { useModelShowPricing } from './useModelShowPricing.js';
import './ModelShowPricingCard.css';

function parseIntOrZero(value: string): number {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function ModelOtherRatesCard(): ReactElement {
  const { pricing, setPricing, isLoading, isSaving, error, save } = useModelShowPricing();

  if (isLoading) {
    return <p style={{ color: 'var(--fm-color-text-muted)' }}>{t('common.studio.pricing.loading')}</p>;
  }

  if (!pricing) {
    return <p className="fm-error">{error ?? t('common.studio.pricing.loadError')}</p>;
  }

  return (
    <div className="fm-card">
      <h2 style={{ marginTop: 0 }}>{t('common.studio.pricing.otherRatesTitle')}</h2>
      <p style={{ color: 'var(--fm-color-text-muted)' }}>{t('common.studio.pricing.otherRatesHint')}</p>

      <div className="studio-pricing-fields">
        <label>
          {t('common.studio.pricing.partyMin')}
          <input
            type="number"
            min={2}
            value={pricing.partyMinParticipants}
            onChange={(event) => {
              setPricing({
                ...pricing,
                partyMinParticipants: Math.max(2, parseIntOrZero(event.target.value)),
              });
            }}
          />
        </label>
        <label>
          {t('common.studio.pricing.ticketPrice')}
          <input
            type="number"
            min={5}
            value={pricing.ticketPriceCoins}
            onChange={(event) => {
              setPricing({
                ...pricing,
                ticketPriceCoins: parseIntOrZero(event.target.value),
              });
            }}
          />
        </label>
        <label>
          {t('common.studio.pricing.fanClubPrice')}
          <input
            type="number"
            min={5}
            value={pricing.fanClubMonthlyCoins}
            onChange={(event) => {
              setPricing({
                ...pricing,
                fanClubMonthlyCoins: parseIntOrZero(event.target.value),
              });
            }}
          />
        </label>
      </div>

      {error ? <p className="fm-error">{error}</p> : null}
      <div style={{ marginTop: '1rem' }}>
        <Button
          label={isSaving ? t('common.studio.pricing.saving') : t('common.studio.pricing.saveOtherRates')}
          onClick={() => {
            void save({
              partyMinParticipants: pricing.partyMinParticipants,
              ticketPriceCoins: pricing.ticketPriceCoins,
              fanClubMonthlyCoins: pricing.fanClubMonthlyCoins,
            });
          }}
          disabled={isSaving}
        />
      </div>
    </div>
  );
}
